export default __webpack_public_path__ + "static/media/New_Header_Image.abe23e56.png";